import { useQuery } from "@tanstack/react-query";
import { apiGet } from "./client";

/** The pages whose cards are compared with an earlier month or year, and so say what date they are as of. Same names as GET /as-of's `page`. */
export type AsOfPage =
  | "net-investment"
  | "industry-benchmark"
  | "exposure-tracking"
  | "earnings-return"
  | "watchlist"
  | "apd-monitoring"
  | "epd";

/** The date (YYYY-MM-DD) the page's cards are as of: the latest file date of the table the page reads. `null` when that table is empty. */
export function useAsOf(page: AsOfPage) {
  return useQuery({
    queryKey: ["pp-as-of", page],
    staleTime: 5 * 60_000,
    queryFn: () => apiGet<{ page: string; asOf: string | null }>("/as-of", { page }),
  });
}
